import * as React from 'react';

export function useGetLatest<T>(obj: T) {
  const ref = React.useRef<T>(obj);
  ref.current = obj;

  return React.useCallback(() => ref.current, []);
}
